import { useState } from "react";
import { storySegments } from "@/mocks/content";
import { Reveal, SectionHeading } from "./common";

export default function Story() {
  const [openId, setOpenId] = useState(storySegments[0].id);

  const toggle = (id: string) => setOpenId((prev) => (prev === id ? "" : id));

  return (
    <section id="story" className="section-anchor w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 max-w-5xl mx-auto">
        <Reveal>
          <SectionHeading
            eyebrow="剧情梳理"
            title="按篇章理清故事：从裂缝到收束"
            desc="把善良的嫂子分集剧情的推进逻辑拆成四个篇章，点击任意篇章即可展开完整梳理，方便快速回顾关键节点。"
          />
        </Reveal>

        <div className="mt-8 md:mt-10 space-y-3 md:space-y-4">
          {storySegments.map((seg, i) => {
            const isOpen = openId === seg.id;
            return (
              <Reveal key={seg.id} delay={i * 60}>
                <div
                  className={`rounded-lg border transition-colors ${
                    isOpen ? "bg-background-100 border-primary-300" : "bg-background-50 border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => toggle(seg.id)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center gap-4 text-left p-4 md:p-5 cursor-pointer"
                  >
                    <span
                      className={`service-icon-wrap shrink-0 rounded-md flex items-center justify-center text-xs font-semibold transition-colors ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="flex-1 min-w-0">
                      <span className="block text-[11px] font-label tracking-widest text-accent-700">
                        {seg.stage}
                      </span>
                      <span className="block font-heading text-sm md:text-lg font-semibold text-foreground-950">
                        {seg.title}
                      </span>
                    </span>
                    <i
                      className={`shrink-0 text-xl text-foreground-500 transition-transform ${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    ></i>
                  </button>
                  {isOpen && (
                    <div className="px-4 md:px-5 pb-5 pl-[4.5rem] md:pl-20 animate-fade-in-down">
                      <div className="space-y-3">
                        {seg.paragraphs.map((p) => (
                          <p key={p.slice(0, 12)} className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                            {p}
                          </p>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}